import styled from 'styled-components'
import { theme } from '../../../../styles/styles'

export const Card = styled.div`
  background: ${theme.colors.white};
  box-shadow: 0 4px 8px rgba(189, 189, 189, 0.2);
  padding: 40px 30px;
`
